<template>
  <div>
    <ul
      class="list-disc !ml-[16px] !mb-[8px]"
    >
      <li
        v-for="material in items || []"
        :key="material.id"
      >
        <div
          class="flex items-center gap-2 justify-between"
        >
          <span>{{ material.name }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
/**
   * List of packing materials
   * @prop {Array} items - The array of packing materials
   * @returns {void}
   */
export default {
  name: 'PackingsCell',
  props: {
    items: {
      type: Array,
      required: false,
      default() {
        return []
      },
    },
  },
}
</script>
